import type { SenderProxyFormat, SenderProxyProtocol } from '@/entities/sender.entity';

const STATUS_LABELS: Record<string, string> = {
	available: 'Доступна',
	assigned: 'Назначена',
	resting: 'Отлежка',
	cooldown: 'Cooldown',
	retired: 'Выведена',
};

const FORMAT_LABELS: Record<SenderProxyFormat, string> = {
	auto: 'Авто',
	url: 'URL',
	host_port: 'host:port',
	host_port_user_pass: 'host:port:user:pass',
	user_pass_at_host_port: 'user:pass@host:port',
	user_pass_host_port: 'user:pass:host:port',
	host_port_user_pass_pipe: 'host:port|user:pass',
};

const PROTOCOL_LABELS: Record<SenderProxyProtocol, string> = {
	socks5: 'SOCKS5',
	http: 'HTTP',
};

export function proxyStatusLabel(status: string): string {
	return STATUS_LABELS[status] ?? status;
}

export function proxyFormatLabel(format: SenderProxyFormat): string {
	return FORMAT_LABELS[format] ?? format;
}

export function proxyProtocolLabel(protocol: SenderProxyProtocol): string {
	return PROTOCOL_LABELS[protocol] ?? protocol;
}
